__webpack_require__.p = "/tello-ecommerce-reactjs/";